<template>
  <div class="no-data">
    <img src="@/assets/imgs/empty.png" />
    <div>暂无数据～</div>
  </div>
</template>
<style lang="less" scoped>
.no-data {
  text-align: center;
  margin-top: 20px;
  div {
    color: @text-secondary;
    margin-top: 10px;
    font-size: 14px;
  }
}
</style>